import { render } from "./HomeView.vue?vue&type=template&id=ef2b96a0"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=ef2b96a0&lang=css"

import exportComponent from "/Users/peterdevos/Apps/sthree_grijper/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__